export default __webpack_public_path__ + "static/media/CameraIcon.3c08a4eb.svg";